import { useEffect, useRef, useState } from "react";
import { ArrowUpIcon } from "@heroicons/react/24/outline";

const SCROLL_THRESHOLD = 360;

const getScrollElement = (target) => {
  if (!target || target === document || target === window) {
    return document.scrollingElement || document.documentElement;
  }
  if (target.nodeType === 1) {
    return target;
  }
  return null;
};

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);
  const scrollerRef = useRef(null);

  useEffect(() => {
    const onScroll = (event) => {
      const el = getScrollElement(event.target);
      if (!el || el.scrollHeight <= el.clientHeight + 8) {
        return;
      }
      scrollerRef.current = el;
      setVisible(el.scrollTop > SCROLL_THRESHOLD);
    };

    document.addEventListener("scroll", onScroll, {
      capture: true,
      passive: true,
    });
    return () => {
      document.removeEventListener("scroll", onScroll, { capture: true });
    };
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <button
      type="button"
      className="fixed bottom-5 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary text-white shadow-lg transition hover:bg-primary-600"
      aria-label="Scroll to top"
      onClick={() => {
        const el = scrollerRef.current;
        if (!el) {
          return;
        }
        if (typeof el.scrollTo === "function") {
          el.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          el.scrollTop = 0;
        }
      }}
    >
      <ArrowUpIcon className="h-5 w-5" strokeWidth={2.5} />
    </button>
  );
}
